import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { Input, TextArea } from "uxp/components";
import { hasValue } from "../../../../util";
import { Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";

interface ITextAreaFieldProperty extends IBaseInputFieldProperty {
	rows?: number,
	cols?: number,
	fieldLabel:IFieldTitleProps,

}

export const Field: React.FunctionComponent<IUIFieldProps<ITextAreaFieldProperty>> = (props) => {
	let { value, onChange, rows, cols } = props?.fieldProps || {};

	let styles: React.CSSProperties = {}

	return (
		<div className={`ui-field ${props.mode}`} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {} } />
			<TextArea
				value={value || ''}
				onChange={onChange}
				rows={rows}
				cols={cols}
			/>
		</div>
	)
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ITextAreaFieldProperty>> = (props) => {

	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Text Input</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Value</PropertyTitle>
				<TextArea
					value={props.uiProps.value || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { value: s }))}
					className="widget-designer-input"
				/>
			</Property>

			{/* <Property>
				<PropertyTitle>Columns</PropertyTitle>
				<Input
					type="number"
					value={props.uiProps.cols?.toString() || '50'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { cols: Number(s) }))}
					className="widget-designer-input"
				/>
			</Property> */}

			<Property>
				<PropertyTitle>Rows</PropertyTitle>
				<Input
					type="number"
					value={props.uiProps.rows?.toString() || '2'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { rows: Number(s) }))}
					className="widget-designer-input"
				/>
			</Property>


			{/* <Property>
				<PropertyTitle>Text Color </PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.textColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { textColor: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Align</PropertyTitle>
				<TextAlignEditor
					value={props.uiProps.textAlign || 'left'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { textAlign: s }))}
				/>
			</Property>

			<Property>
				<PropertyTitle>Background Color </PropertyTitle>
				<CustomColorPicker contextData={props.contextData}
					color={props.uiProps.backgroundColor || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { backgroundColor: s }))}
				/>
			</Property> */}

		<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />

		</PropertyGroup>
	</PropertyContainer>;
}

registerUIField({
	id: 'textarea',
	category: 'inputs',
	description: 'Long Text',
	field: Field,
	propertyEditor: PropertyEditor,
	isInputField: true,
	defaultProps: {
		fieldLabel: {
			label:'Notes'
		}
	},
	type:'notes'

});
